module.exports = __webpack_public_path__ + "img/orange_127.4a5b2d9f.png";